export const createStyles = (isMobile, isDark) => {
  const colors = {
    bg: isDark ? "#0f172a" : "#f8fafc",
    text: isDark ? "#f1f5f9" : "#1e293b",
    cardBg: isDark ? "#1e293b" : "white",
    cardBorder: isDark ? "#334155" : "#e2e8f0",
    inputBg: isDark ? "#334155" : "white",
    inputBorder: isDark ? "#475569" : "#cbd5e1",
    muted: isDark ? "#94a3b8" : "#64748b",
    hover: isDark ? "#334155" : "#f1f5f9",
    primary: "#3b82f6",
    success: "#16a34a",
    danger: "#dc2626",
    warning: "#d97706",
    glass: isDark ? "rgba(30, 41, 59, 0.7)" : "rgba(255, 255, 255, 0.8)",
    glassBorder: isDark ? "rgba(71, 85, 105, 0.5)" : "rgba(203, 213, 225, 0.6)",
  };

  // Красим весь фон страницы (body), чтобы убрать белые полосы по бокам
  if (typeof document !== 'undefined') {
    document.body.style.backgroundColor = colors.bg;
    document.body.style.color = colors.text;
    document.body.style.margin = "0"; // Гарантируем отсутствие отступов у браузера
  }

  const base = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: isMobile ? "10px" : "20px",
      fontFamily: '"Segoe UI", Roboto, sans-serif',
      color: colors.text,
      minHeight: "100vh",
      paddingBottom: "80px",
      transition: "0.3s",
    },
    header: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: isMobile ? "flex-start" : "center",
      marginBottom: "20px",
      paddingBottom: "15px",
      borderBottom: `1px solid ${colors.cardBorder}`,
      gap: "15px",
    },
    card: {
      border: `1px solid ${colors.cardBorder}`,
      borderRadius: "12px",
      padding: isMobile ? "15px" : "24px",
      marginBottom: "20px",
      backgroundColor: colors.cardBg,
      boxShadow: isDark ? "none" : "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
      position: "relative",
    },
    glassCard: {
      background: colors.glass,
      border: `1px solid ${colors.glassBorder}`,
      borderRadius: "12px",
      overflow: "hidden",
      marginBottom: "20px",
      color: colors.text,
      backdropFilter: "blur(5px)",
      transition: "all 0.3s ease",
    },
    btn: {
      padding: "10px 16px",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontWeight: "600",
      fontSize: "14px",
      transition: "0.2s",
      width: isMobile ? "100%" : "auto",
      justifyContent: "center",
    },
    btnPrimary: {
      backgroundColor: colors.primary,
      color: "white",
    },
    btnSecondary: {
      backgroundColor: colors.cardBg,
      color: colors.text,
      border: `1px solid ${colors.inputBorder}`,
    },
    input: {
      padding: "8px",
      borderRadius: "6px",
      border: `1px solid ${colors.inputBorder}`,
      width: "100%",
      boxSizing: "border-box",
      outline: "none",
      fontSize: "16px",
      backgroundColor: colors.inputBg,
      color: colors.text,
      minWidth: 0,
    },
    select: {
      padding: "10px",
      borderRadius: "6px",
      border: `1px solid ${colors.inputBorder}`,
      width: "100%",
      backgroundColor: colors.inputBg,
      color: colors.text,
      outline: "none",
      fontSize: "16px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "0",
      fontSize: isMobile ? "13px" : "14px",
      tableLayout: "fixed",
    },
    th: {
      textAlign: "left",
      padding: "10px",
      borderBottom: `2px solid ${colors.cardBorder}`,
      backgroundColor: isDark ? "#0f172a" : "#f8fafc",
      color: colors.muted,
    },
    td: {
      padding: "10px",
      borderBottom: `1px solid ${colors.cardBorder}`,
      verticalAlign: "middle",
      whiteSpace: "normal",
      wordBreak: "normal",
    },
    thRight: {
      textAlign: "right",
      padding: "10px",
      borderBottom: `2px solid ${colors.cardBorder}`,
      backgroundColor: isDark ? "#0f172a" : "#f8fafc",
      color: colors.muted,
    },
    tdRight: {
      padding: "10px",
      borderBottom: `1px solid ${colors.cardBorder}`,
      verticalAlign: "middle",
      textAlign: "right",
      whiteSpace: "normal",
      wordBreak: "normal",
    },
    mobileGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr) auto",
      gap: "15px",
      alignItems: "end",
    },
    label: {
      display: "block",
      marginBottom: "5px",
      fontSize: "12px",
      color: colors.muted,
      fontWeight: "600",
    },
  };

  const admin = {
    accordionHeader: {
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      background: isDark ? "rgba(30, 41, 59, 0.4)" : "rgba(241, 245, 249, 0.8)",
    },
    accordionContent: {
      padding: "0 20px 20px 20px",
      borderTop: `1px solid ${isDark ? "rgba(71, 85, 105, 0.3)" : "#e2e8f0"}`,
    },
    inputGroup: {
      display: "flex",
      gap: "0",
      marginBottom: "15px",
      marginTop: "15px",
    },
    darkInput: {
      flex: 1,
      background: colors.inputBg,
      border: `1px solid ${colors.inputBorder}`,
      borderRight: "none",
      color: colors.text,
      padding: "10px 15px",
      borderRadius: "8px 0 0 8px",
      outline: "none",
      fontSize: "14px",
    },
    addButton: {
      background: colors.primary,
      color: "white",
      border: "none",
      padding: "0 20px",
      borderRadius: "0 8px 8px 0",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    hallChip: {
      display: "flex",
      alignItems: "center",
      background: isDark ? "#334155" : "#e2e8f0",
      padding: "6px 12px",
      borderRadius: "6px",
      border: `1px solid ${isDark ? "#475569" : "#cbd5e1"}`,
      fontSize: "14px",
      color: colors.text,
    },
  };

  const editor = {
    grid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 2fr",
      gap: "20px",
    },
    sidebar: {
      maxHeight: isMobile ? "300px" : "80vh",
      overflowY: "auto",
      padding: "10px",
    },
    summaryBox: {
      background: colors.cardBg,
      padding: "15px",
      borderRadius: "12px",
      border: `1px solid ${colors.cardBorder}`,
    },
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalContent: {
      ...base.card,
      width: "90%",
      maxWidth: "500px",
      margin: 0,
      position: "relative",
    },
    itemComment: {
      flex: 1,                 
      minWidth: "100px",       
      background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)", 
      border: `1px solid ${colors.inputBorder}`, 
      borderRadius: "4px",
      color: colors.text,
      fontSize: "12px",
      fontStyle: "italic",
      outline: "none",
      padding: "4px 8px",
    },
    dragHandle: {
        cursor: "grab",
        color: isDark ? "#e2e8f0" : "#475569", 
        background: isDark ? "#334155" : "#e2e8f0", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "24px", 
        height: "24px",
        borderRadius: "4px",
        transition: "0.2s",
        "&:hover": {
            color: "white",
            background: colors.primary
        }
    }
  };

  const accordion = {
    wrapper: {
      marginBottom: "10px",
      border: `1px solid ${colors.cardBorder}`,
      borderRadius: "8px",
      overflow: "hidden",
      backgroundColor: colors.cardBg,
    },
    header: (isOpen) => ({
      padding: "10px 15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: isOpen ? colors.hover : "transparent",
    }),
    title: (isOpen) => ({
      fontWeight: "bold",
      color: isOpen ? colors.primary : colors.text,
    }),
  };

  const list = {
    searchContainer: {
      ...base.card,
      marginBottom: "20px",
      padding: "15px",
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
      alignItems: "center",
    },
    banquetCard: (statusColor) => ({
      ...base.card,
      marginBottom: 0,
      cursor: "pointer",
      borderLeft: `4px solid ${statusColor}`,
      position: "relative",
    }),
    pinButton: (isPinned) => ({
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "none",
      border: "none",
      color: isPinned ? colors.warning : colors.inputBorder,
      cursor: "pointer",
    }),
  };

  const topBar = {
    container: {
      display: "flex",
      gap: "10px",
      marginBottom: "10px",
      justifyContent: "flex-end",
    },
    select: {
      ...base.select,
      padding: "8px 30px 8px 10px",
      cursor: "pointer",
    },
    globe: {
      position: "absolute",
      right: "10px",
      top: "12px",
      pointerEvents: "none",
      opacity: 0.5,
    }
  };

  return { colors, ...base, admin, editor, accordion, list, topBar };
};